import { DeliveryMode, ORDER_METHODS } from '../../services/exports/Constants';
import { CompanyDetailsInterface, OrderData } from '../../services/exports/Interfaces';

interface Args {
  order: Partial<OrderData>;
  company: Partial<CompanyDetailsInterface> | null | undefined;
  /** The guest confirmed the order-method details in this tab (`isOrderMethodInfoComplete`). */
  confirmed: boolean;
  isAtTable: boolean;
}

/**
 * Whether the basket can go to checkout without the order-method modal. A table order is complete by
 * its table alone: the per-tab flag goes when a pause or a new tab clears it, and the modal has no
 * table to choose.
 */
export default function orderMethodInfoComplete({ order, company, confirmed, isAtTable }: Args): boolean {
  if (order?.method === ORDER_METHODS.ON_SITE) {
    return isAtTable;
  }

  if (!confirmed) {
    return false;
  }

  if (order?.method === ORDER_METHODS.PICKUP) {
    return true;
  }

  if (order?.method !== ORDER_METHODS.DELIVERY || !order?.delivery_zone?.id) {
    return false;
  }

  return (
    company?.delivery_mode === DeliveryMode.Internal ||
    (company?.delivery_mode === DeliveryMode.External && !!order?.delivery_quote?.id)
  );
}
